// Banner copy for the supported languages. Kept in one place so it is easy to
// extend (add a language by adding a key) — part of the "ausbauen" goal.

interface Section {
  title: string;
  description: string;
}

interface Translation {
  consentModal: {
    title: string;
    description: string;
    acceptAllBtn: string;
    acceptNecessaryBtn: string;
    showPreferencesBtn: string;
  };
  preferencesModal: {
    title: string;
    acceptAllBtn: string;
    acceptNecessaryBtn: string;
    savePreferencesBtn: string;
    closeIconLabel: string;
  };
  sections: {
    intro: Section;
    necessary: Section;
    analytics: Section;
    ads: Section;
    functional: Section;
  };
  links: {
    privacy: string;
    imprint: string;
  };
  card: {
    details: string;
    description: string;
    company: string;
    privacy: string;
    cookies: string;
    purposes: string;
    technologies: string;
    data: string;
  };
}

export const translations: Record<'de' | 'en', Translation> = {
  de: {
    consentModal: {
      title: 'Wir verwenden Cookies',
      description:
        'Wir nutzen Cookies und ähnliche Technologien, um unsere Website zu betreiben sowie – mit Ihrer Einwilligung – für Analyse, Marketing und Reichweitenmessung. Sie können Ihre Auswahl jederzeit anpassen.',
      acceptAllBtn: 'Alle akzeptieren',
      acceptNecessaryBtn: 'Nur notwendige',
      showPreferencesBtn: 'Einstellungen',
    },
    preferencesModal: {
      title: 'Cookie-Einstellungen',
      acceptAllBtn: 'Alle akzeptieren',
      acceptNecessaryBtn: 'Nur notwendige',
      savePreferencesBtn: 'Auswahl speichern',
      closeIconLabel: 'Schließen',
    },
    sections: {
      intro: {
        title: 'Datenschutz-Einstellungen',
        description:
          'Hier können Sie auswählen, welche Kategorien von Cookies Sie zulassen möchten. Notwendige Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.',
      },
      necessary: {
        title: 'Notwendig',
        description:
          'Diese Cookies sind für die Grundfunktionen der Website erforderlich und immer aktiv.',
      },
      analytics: {
        title: 'Statistik',
        description:
          'Helfen uns zu verstehen, wie Besucher die Website nutzen (z. B. Google Analytics über den Google Tag Manager).',
      },
      ads: {
        title: 'Marketing',
        description:
          'Werden für personalisierte Werbung und Reichweitenmessung verwendet (z. B. Google Ads über den Google Tag Manager).',
      },
      functional: {
        title: 'Externe Medien & Funktionen',
        description:
          'Erlauben das Laden eingebetteter Inhalte (z. B. YouTube, Google Maps, Vimeo) sowie erweiterte Funktionen wie Anrufverfolgung (Calltracking). Ohne Einwilligung bleiben externe Medien blockiert.',
      },
    },
    links: {
      privacy: 'Datenschutzerklärung',
      imprint: 'Impressum',
    },
    card: {
      details: 'Details anzeigen',
      description: 'Beschreibung des Dienstes',
      company: 'Verarbeitendes Unternehmen',
      privacy: 'Datenschutzerklärung des Anbieters',
      cookies: 'Cookie-Richtlinie',
      purposes: 'Zweck der Daten',
      technologies: 'Genutzte Technologien',
      data: 'Gesammelte Daten',
    },
  },
  en: {
    consentModal: {
      title: 'We use cookies',
      description:
        'We use cookies and similar technologies to operate this website and — with your consent — for analytics, marketing and audience measurement. You can change your choice at any time.',
      acceptAllBtn: 'Accept all',
      acceptNecessaryBtn: 'Necessary only',
      showPreferencesBtn: 'Preferences',
    },
    preferencesModal: {
      title: 'Cookie preferences',
      acceptAllBtn: 'Accept all',
      acceptNecessaryBtn: 'Necessary only',
      savePreferencesBtn: 'Save preferences',
      closeIconLabel: 'Close',
    },
    sections: {
      intro: {
        title: 'Privacy preferences',
        description:
          'Choose which categories of cookies you want to allow. Necessary cookies are required for the website to function and cannot be disabled.',
      },
      necessary: {
        title: 'Necessary',
        description: 'Required for the basic functionality of the website and always active.',
      },
      analytics: {
        title: 'Analytics',
        description:
          'Help us understand how visitors use the website (e.g. Google Analytics via Google Tag Manager).',
      },
      ads: {
        title: 'Marketing',
        description:
          'Used for personalized advertising and audience measurement (e.g. Google Ads via Google Tag Manager).',
      },
      functional: {
        title: 'External media & functional',
        description:
          'Allow loading of embedded content (e.g. YouTube, Google Maps, Vimeo) and advanced features such as call tracking. Without consent, external media stays blocked.',
      },
    },
    links: {
      privacy: 'Privacy policy',
      imprint: 'Imprint',
    },
    card: {
      details: 'Show details',
      description: 'Service description',
      company: 'Processing company',
      privacy: "Provider's privacy policy",
      cookies: 'Cookie policy',
      purposes: 'Purpose of data',
      technologies: 'Technologies used',
      data: 'Collected data',
    },
  },
};
